import { io } from "socket.io-client";

const socket = io(process.env.REACT_APP_SERVER_URL, {
  transports: ["websocket"],
  reconnection: true,
  reconnectionAttempts: 10,
});

export default socket;